import { Button, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import SubCard from 'ui-component/cards/SubCard'
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// import SearchIcon from '@mui/icons-material/Search';
// import { fontSize } from '@mui/system';

const FilterComponent = (props) => {

    console.log("props", props);

    return (
        <SubCard>
            <Grid container spacing={2} alignItems="center">

                <Grid item md={3} xs={12}>
                    <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600}>FOS</Typography>
                    <FormControl fullWidth size='small'>
                        {/* <InputLabel id="demo-simple-select-label">Fos</InputLabel> */}
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={props.fos ? props.fos : "select"}
                            onChange={(e) => props.handleChange("fos", e.target.value === 'select' ? null : e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: '2px solid #A9A9A980 50%', // change border color
                                    borderRadius: '8px', // change border radius
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    border: '2px solid #A9A9A980 50%', // change border color
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    border: '2px solid #A9A9A980 50%', // change border color
                                },
                            }}

                        >
                            <MenuItem value="select">Select</MenuItem>
                            {
                                props.data && Array.isArray(props.data) && props.data.map((fos) => (
                                    <MenuItem key={fos._id} value={fos._id}>{fos.username}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Grid>


                <Grid item md={3} xs={12} >
                    <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600} >CSP Code</Typography>
                    <TextField
                        id="outlined-basic"
                        variant="outlined"
                        size='small'
                        // disabled={props.fos ? false : true}
                        value={props.agentCode ? props.agentCode : ""}
                        fullWidth
                        onChange={(e) => e.target.value.length < 15 ? props.handleChange("csp_code", e.target.value) : null}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                border: '2px solid #A9A9A980 50%', // change border color
                                borderRadius: '8px',
                            },
                            '& fieldset': {
                                // backgroundColor:props.fos?"none":"#ededed", 
                                borderColor: '#A9A9A980',
                                borderRadius: '8px',
                                color: "#000"// default border color
                            },
                        }}



                    />

                </Grid>

                <Grid item md={1} xs={12} mt={3}>
                    <Button size='medium' disabled={!props.agentCode ? true : false} fullWidth sx={{ borderRadius: '8px' }} variant='contained' color='secondary' onClick={props.handleSearch}>
                        Search
                    </Button>
                </Grid>

                <Grid item md={1} xs={12} mt={3}>
                    <Button size='medium' fullWidth sx={{ borderRadius: '8px' }} variant='contained' color='warning' onClick={props.handleClear}>
                        Clear
                    </Button>
                </Grid>
            </Grid>
        </SubCard>
    )
}

export default FilterComponent